import { TableCompHead } from '../../../../components/ui';
import { useQuery } from '../../../../hooks/UseQuery';
import { getColumnLength } from '../../helpers/utils';

interface IProps {
  moduleData: any;
  isView: boolean;
}
const style1 = {
  backgroundColor: '#4F81BD',
  color: '#fff',
  minWidth: '100px',
};
const style2 = {
  backgroundColor: '#00B050',
  color: '#fff',
  minWidth: '80px',
};
const THead = ({ moduleData, isView }: IProps) => {
  const annual_date = useQuery('annual_date');
  const numberOfDays = getColumnLength(annual_date || '');

  return (
    <thead>
      <TableCompHead
        // colSpan={numberOfDays + 13}
        colSpan={21}
        rowSpan={1}
        labels={[]}
        values={[]}
        headingStyle={{
          position: 'sticky',
          top: '0rem',
          zIndex: 1,
        }}
        heading={`RM Planning ${annual_date}`}
      />
      <tr
        style={{
          position: 'sticky',
          top: '3rem',
          zIndex: 1,
        }}
      >
        <th style={style1}>Customer</th>
        <th style={style1}>Part Code</th>
        <th style={style1}>Part Name</th>

        <th style={style1}>RM GRADE</th>
        <th style={style1}>Sale price</th>
        <th style={style1}>THICK (MM)</th>
        <th style={style1}>WIDTH (MM)</th>
        <th style={style1}>LENGTH (MM)</th>
        <th style={style1}>STRIP WT</th>
        <th style={style1}>NO OF PC</th>
        <th style={style1}>Gross Wt</th>
        <th style={style1}>Inventory (kg RM)</th>
        <th style={style1}>Inventory (Qty WIP)</th>
        <th style={style1}>Total Inventory (Qty)</th>
        <th style={style1}>Sale Plan (Qty)</th>
        <th style={style1}>RM required (Qty)</th>
        <th style={style1}>RM required (Kg)</th>
        <th style={style1}>RM Input (Kg)</th>
        <th style={style1}>Balance RM Req (Kg)</th>
        <th style={style1}>Dispatch (Qty)</th>
        <th style={style1}>Closing Inventory (Qty)</th>
      </tr>
    </thead>
  );
};

export default THead;
